import type { BackendRouteDefinition } from '../types';
import { clientAuthRoutes } from './clientAuth';
import { getApiVersionRoute } from './getApiVersion';
import { getFirmInfoForHandleRoute } from './getFirmInfoForHandle';
import { paymentRoutes } from './payments';

export { getFirmInfoForHandleRoute } from './getFirmInfoForHandle';

export const routeTable = {
  getApiVersion: getApiVersionRoute,
  getFirmInfoForHandle: getFirmInfoForHandleRoute,
  ...clientAuthRoutes,
  ...paymentRoutes,
} as const satisfies Record<string, BackendRouteDefinition>;
